import { store } from "../configureStore";
import { CENTRAL_DASHBOARD_BACKEND_API } from "./envConfig";

import request from "./request";
import { resetAnalyticsUser } from "./analytics";
const BASE_URL = CENTRAL_DASHBOARD_BACKEND_API;

export const apiCall = (
  url,
  options = {},
  actionName = null,
  loadType = null,
  extraInfo
) => {
  url = url.startsWith("http") ? url : BASE_URL + url;
  // console.log("%c@apiCall: ", "color:green", url, options);

  if (actionName) {
    store?.dispatch({
      type: loadType
        ? `FETCH_${actionName}_${loadType}_REQUEST`
        : `FETCH_${actionName}_REQUEST`,
    });
  }
  return new Promise((resolve, reject) => {
    // console.log("options", options);

    request(url, {
      ...options,
      headers: options.headers,
    })
      .then((response) => {
        if (actionName) {
          if (
            response &&
            response.status &&
            response.status.message &&
            (response.status.message == "Unauthorized" ||
              response.status.message == "invalid token" ||
              response.status.message == "email mismatch" ||
              response.status.message == "token missing")
          ) {
            console.log("actionName:", actionName);
            console.log("Logout User");
            resetAnalyticsUser(true);
            store.dispatch({
              type: "ON_LOGOUT",
            });
          } else {
            store.dispatch({
              type: loadType
                ? `FETCH_${actionName}_${loadType}_SUCCESS`
                : `FETCH_${actionName}_SUCCESS`,
              payload: response,
              extraInfo,
            });
          }
        }

        // else {
        //   console.log("Response:", response);
        //   console.log("Logout User");
        //   localStorage.removeItem("userData");
        //   store.dispatch({
        //     type: "ON_LOGOUT",
        //   });
        // }
        resolve(response);
      })
      .catch((error) => {
        if (error?.status === 401) {
          resetAnalyticsUser(true);
          store.dispatch({ type: "ON_LOGOUT" });
        }
        else if (actionName) store.dispatch({
          type: loadType ? `FETCH_${actionName}_${loadType}_ERROR` : `FETCH_${actionName}_ERROR`,
          payload: error,
        });
        reject(error);
      });
  });
};
